module.exports = __webpack_public_path__ + "img/icon2.db95fb1d.svg";